import { render, staticRenderFns } from "./vNutritionLabelUS.vue?vue&type=template&id=71f386bc&scoped=true"
import script from "./vNutritionLabelUS.vue?vue&type=script&lang=ts"
export * from "./vNutritionLabelUS.vue?vue&type=script&lang=ts"
import style0 from "./vNutritionLabelUS.vue?vue&type=style&index=0&id=71f386bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f386bc",
  null
  
)

export default component.exports